<div class="invoicing-list__stats">
    <div class="invoicing-list__stat invoicing-list__stat--total">
        <div class="invoicing-list__stat-icon">
            <i class="ti ti-currency-dollar"></i>
        </div>
        <div class="invoicing-list__stat-info">
            <span class="invoicing-list__stat-label">Total facturado</span>
            <span class="invoicing-list__stat-value">{{ formatCurrency(stats.total_amount) }}</span>
            <span class="invoicing-list__stat-sub">{{ monthLabel }}</span>
        </div>
    </div>

    <div class="invoicing-list__stat invoicing-list__stat--issued">
        <div class="invoicing-list__stat-icon">
            <i class="ti ti-file-invoice"></i>
        </div>
        <div class="invoicing-list__stat-info">
            <span class="invoicing-list__stat-label">Facturas emitidas</span>
            <span class="invoicing-list__stat-value">{{ stats.issued_count }}</span>
            <span class="invoicing-list__stat-sub">{{ monthLabel }}</span>
        </div>
    </div>

    <div class="invoicing-list__stat invoicing-list__stat--pending">
        <div class="invoicing-list__stat-icon">
            <i class="ti ti-clock"></i>
        </div>
        <div class="invoicing-list__stat-info">
            <span class="invoicing-list__stat-label">Pendientes de pago</span>
            <span class="invoicing-list__stat-value">{{ formatCurrency(stats.pending_amount) }}</span>
            <span class="invoicing-list__stat-sub">{{ monthLabel }}</span>
        </div>
    </div>

    <div class="invoicing-list__stat invoicing-list__stat--paid">
        <div class="invoicing-list__stat-icon">
            <i class="ti ti-circle-check"></i>
        </div>
        <div class="invoicing-list__stat-info">
            <span class="invoicing-list__stat-label">Facturas pagadas</span>
            <span class="invoicing-list__stat-value">{{ stats.paid_count }}</span>
            <span class="invoicing-list__stat-sub">{{ monthLabel }}</span>
        </div>
    </div>

    <div class="invoicing-list__stat invoicing-list__stat--stamps"
         *ngIf="showStampBalance && (stampBalance || stampBalanceLoading)"
         [style.borderLeft]="stampBalance ? ('4px solid ' + (stampBalance.level === 'red' ? '#dc3545' : stampBalance.level === 'yellow' ? '#ffc107' : '#28a745')) : ''"
         title="Timbres disponibles en SW">
        <div class="invoicing-list__stat-icon"
             [style.color]="stampBalance ? (stampBalance.level === 'red' ? '#dc3545' : stampBalance.level === 'yellow' ? '#ffc107' : '#28a745') : ''">
            <i class="ti ti-stamp"></i>
        </div>
        <div class="invoicing-list__stat-info">
            <span class="invoicing-list__stat-label">Timbres disponibles</span>
            <span class="invoicing-list__stat-value">
                <ng-container *ngIf="stampBalanceLoading">…</ng-container>
                <ng-container *ngIf="!stampBalanceLoading && stampBalance">
                    {{ stampBalance.is_unlimited ? 'Ilimitado' : (stampBalance.stamps_balance | number) }}
                </ng-container>
            </span>
            <span class="invoicing-list__stat-sub" style="cursor:pointer" (click)="loadStampBalance(true)">
                <i class="ti ti-refresh"></i> Actualizar
            </span>
        </div>
    </div>
</div>

<div class="invoicing-list__filters">
    <div class="invoicing-list__filter invoicing-list__filter--search">
        <label class="invoicing-list__filter-label">Buscar</label>
        <div class="invoicing-list__search">
            <input
                type="text"
                class="form-control invoicing-list__search-input"
                [(ngModel)]="searchText"
                (keydown)="onSearchKeydown($event)"
                placeholder="Folio, cliente...">
            <button
                type="button"
                class="invoicing-list__search-btn"
                (click)="onSearch()"
                aria-label="Buscar">
                <i class="ti ti-search"></i>
            </button>
        </div>
    </div>

    <div class="invoicing-list__filter">
        <label class="invoicing-list__filter-label">Fecha de creación</label>
        <input
            type="text"
            class="form-control"
            inputmode="numeric"
            autocomplete="off"
            maxlength="10"
            placeholder="dd/mm/aaaa"
            [value]="createdAtDisplay"
            (input)="onCreatedAtInput($event)">
    </div>

    <div class="invoicing-list__filter">
        <label class="invoicing-list__filter-label">Estado factura</label>
        <select class="form-select" [(ngModel)]="statusFilter" (change)="onFilterChange()">
            <option value="">Seleccionar</option>
            <option value="Vigente">Pendiente</option>
            <option value="Pagada">Facturado</option>
            <option value="Cancelada">Cancelado</option>
        </select>
    </div>

    <div class="invoicing-list__filter">
        <label class="invoicing-list__filter-label">Estado pago</label>
        <select class="form-select" [(ngModel)]="paymentStatusFilter" (change)="onFilterChange()">
            <option value="">Seleccionar</option>
            <option value="Pagado">Pagado</option>
            <option value="Vencido">No Pagado</option>
            <option value="Pendiente">Saldo Pendiente</option>
        </select>
    </div>

    <div class="invoicing-list__filter">
        <label class="invoicing-list__filter-label">Método de pago</label>
        <select class="form-select" [(ngModel)]="paymentMethodFilter" (change)="onFilterChange()">
            <option value="">Seleccionar</option>
            <option value="PUE">PUE - Pago en una exhibición</option>
            <option value="PPD">PPD - Pago en parcialidades</option>
        </select>
    </div>

    <div class="invoicing-list__filter invoicing-list__filter--clear" *ngIf="hasActiveFilters()">
        <label class="invoicing-list__filter-label">&nbsp;</label>
        <button
            type="button"
            class="btn invoicing-list__clear-btn invoicing-list__clear-btn--active"
            (click)="clearFilters()"
            aria-label="Limpiar filtros">
            <i class="ti ti-filter-off me-1"></i>
            Limpiar filtros
            <span class="invoicing-list__clear-dot"></span>
        </button>
    </div>
</div>

<div class="ag-theme-alpine" style="height: 600px; width: 100%;">
    <ag-grid-angular
        style="width: 100%; height: 100%;"
        class="ag-theme-alpine"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [loadingCellRenderer]="loadingCellRenderer"
        [loadingCellRendererParams]="loadingCellRendererParams"
        (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>
